import {Component} from '@angular/core';
import {IcGridComponent} from '../ic-grid/ic-grid.component';
import {ActionsService} from '../../Redux/Actions/actions.service';
import {ActivatedRoute, Router} from '@angular/router';
import {removeDuplicate} from "../../common/utils";
import {Observable} from "rxjs";

@Component({
  selector: 'edsng-ic-list',
  templateUrl: './ic-list.component.html',
  styleUrls: ['./ic-list.component.css']
})
export class IcListComponent extends IcGridComponent {

  selectedTab = 0;

  constructor(public act: ActionsService, protected route: ActivatedRoute, protected router: Router) {
    super(act, route, router);
  }

  // getDesignByTopology(t:string):Observable<IDesignSolution[]>{
  //   return this.designSolutions$.map(x=>x.filter(a=>a.topology === t));
  // }
  //
  // getInfosByTopology(t:string):Observable<InfoToShow[]>{
  //   return this.getDesignByTopology(t).map(x=>x.map(({shownInfo})=>shownInfo)[0])
  // }

  getTopologies(): Observable<string[]> {
    return this.designSolutions$.map(x => removeDuplicate(x.map(({topology}) => topology)));
  }
}

